// Cross-programme rows for the Stratus oversight tables. Stratus sees every
// programme, including ones without a full seeded workspace (Karamoja).

import type { ProgrammePhase, FunderVisibility } from "../types";

export type ProgrammeSummary = {
  id: string;
  workspaceId?: string;
  name: string;
  funder: string;
  totalBudget: number;
  milestonesDisbursed: string; // "X / Y"
  milestonesPct: number;
  alertState: "GREEN" | "AMBER" | "RED";
  status: "active" | "on_hold" | "closed";
  projects: number;
  phase?: ProgrammePhase;
  funderVisibility?: FunderVisibility;
};

export type ProjectSummary = {
  id: string;
  workspaceId?: string;
  name: string;
  programme: string;
  contractor: string;
  budgeted: number;
  spent: number;
  // ZEUS-135: widened alongside Project/SubProject's status — see types.ts.
  status: "active" | "planned" | "closed" | "draft" | "review" | "published";
  risk: "GREEN" | "AMBER" | "RED";
};

const B = 1_000_000_000;

// Static third programme (no full workspace seed).
export const karamojaProgramme: ProgrammeSummary = {
  id: "prog-karamoja-water",
  name: "Karamoja Water Access 2026–2028",
  funder: "Danish Impact Fund",
  totalBudget: 22 * B,
  milestonesDisbursed: "0 / 6",
  milestonesPct: 0,
  alertState: "AMBER",
  status: "on_hold",
  projects: 3,
  phase: "feasibility",
  funderVisibility: "shared",
};

// Programmes in earlier phases that prove the engine configures beyond construction
// (pilot-readiness addendum §6). Lake Victoria is equipment-dominated; the referral
// hospital is a portfolio card only. Both are still in feasibility.
export const lakeVictoriaProgramme: ProgrammeSummary = {
  id: "prog-lake-victoria",
  name: "Lake Victoria Oil-Spill Protection 2026–2029",
  funder: "Danish Impact Fund",
  totalBudget: 90 * B,
  milestonesDisbursed: "0 / 5",
  milestonesPct: 0,
  alertState: "GREEN",
  status: "active",
  projects: 1,
  phase: "feasibility",
  funderVisibility: "not_shared",
};

export const referralHospitalProgramme: ProgrammeSummary = {
  id: "prog-referral-hospital",
  name: "Regional Referral Hospital · Construct & Equip",
  funder: "Danish Impact Fund",
  totalBudget: 150 * B,
  milestonesDisbursed: "0 / 8",
  milestonesPct: 0,
  alertState: "GREEN",
  status: "active",
  projects: 1,
  phase: "feasibility",
  funderVisibility: "not_shared",
};

/** Extra portfolio programmes without a full workspace seed (oversight + funder cards). */
export const extraProgrammes: ProgrammeSummary[] = [
  karamojaProgramme,
  lakeVictoriaProgramme,
  referralHospitalProgramme,
];

export const karamojaProjects: ProjectSummary[] = [
  { id: "kw-01", name: "Kotido borehole cluster", programme: "Karamoja Water Access 2026–2028", contractor: "Rift Valley Drilling Ltd", budgeted: 4.5 * B, spent: 0, status: "planned", risk: "AMBER" },
  { id: "kw-02", name: "Moroto reservoir", programme: "Karamoja Water Access 2026–2028", contractor: "Rift Valley Drilling Ltd", budgeted: 6.2 * B, spent: 0, status: "planned", risk: "AMBER" },
];
